import React from 'react'

import fallbackImage from '@app/assets/images/image-fallback.svg'

import { Image } from 'antd'

import type { LntImageProps } from './types'

export const LntImage: React.FC<LntImageProps> = props => {
  const { children, ...restProps } = props

  return (
    <Image
      { ...restProps }
      fallback={ fallbackImage }
    >
      { children }
    </Image>
  )
}
